"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderStyle = void 0;
var BorderStyle;
(function (BorderStyle) {
    BorderStyle["none"] = "none";
    BorderStyle["dotted"] = "dotted";
    BorderStyle["dashed"] = "dashed";
    BorderStyle["solid"] = "solid";
    BorderStyle["double"] = "double";
    BorderStyle["groove"] = "groove";
    BorderStyle["ridge"] = "ridge";
    BorderStyle["inset"] = "inset";
    BorderStyle["outset"] = "outset";
    BorderStyle["hidden"] = "hidden";
})(BorderStyle = exports.BorderStyle || (exports.BorderStyle = {}));
//# sourceMappingURL=css.js.map